import { Card, CardHeader, CardTitle, CardContent } from "@/components/ui/card"
import { Badge } from "@/components/ui/badge"
import { Descriptions, Divider, Empty, List } from "antd"
import moment from "moment"
import { ISimperData } from "@/types"

interface SimperHistoryCardProps {
  simperData: ISimperData[]
}

const simperStatusLabelMap: Record<string, string> = {
  active: "Aktif",
  berlaku: "Berlaku",
  expired: "Tidak Berlaku",
  "tidak berlaku": "Tidak Berlaku",
  pending: "Menunggu",
  "menunggu perpanjangan": "Menunggu Perpanjangan",
  inactive: "Tidak Aktif",
}

const applicationStatusLabelMap: Record<string, string> = {
  new: "Baru",
  baru: "Baru",
  renewal: "Perpanjangan",
  perpanjangan: "Perpanjangan",
  extension: "Refresh",
  refresh: "Refresh",
}

const SimperHistoryCard = ({ simperData }: SimperHistoryCardProps) => {
  return (
    <Card className="border-none shadow-sm overflow-hidden">
      <CardHeader className="bg-muted/20 border-b">
        <CardTitle className="text-xl font-bold text-primary-600">Riwayat Detail Simper</CardTitle>
      </CardHeader>
      <CardContent className="pt-6">
        {simperData && simperData.length > 0 ? (
          <List
            itemLayout="vertical"
            dataSource={simperData}
            renderItem={(item, index) => (
              <List.Item key={index} className="px-0 pb-8 last:pb-0 border-none">
                <div className="flex items-center gap-2 mb-4">
                  <Badge variant="outline" className="bg-primary-50 text-primary-600 border-primary-200">
                    Detail #{index + 1}
                  </Badge>
                  <Badge variant="success" className="bg-emerald-50 text-emerald-600 border-emerald-200">
                    {applicationStatusLabelMap[item.application_status?.toLowerCase() || ""] || item.application_status}
                  </Badge>
                </div>

                <Descriptions size="small" column={{ xs: 1, sm: 2 }} bordered className="bg-white">
                  <Descriptions.Item label="Tipe Kendaraan">{item.vehicle_type}</Descriptions.Item>
                  <Descriptions.Item label="Detail Kendaraan">{item.vehicle_detail || "-"}</Descriptions.Item>
                  <Descriptions.Item label="Tipe Simper">{item.simper_type}</Descriptions.Item>
                  <Descriptions.Item label="Area">{item.area || "-"}</Descriptions.Item>
                  <Descriptions.Item label="Kode Akses">{item.access_code || "-"}</Descriptions.Item>
                  <Descriptions.Item label="Zona">{item.zone || "-"}</Descriptions.Item>
                  <Descriptions.Item label="Tahun / Bulan">
                    {item.year || "-"} / {item.month || "-"}
                  </Descriptions.Item>
                  <Descriptions.Item label="Tanggal Pengajuan">{item.application_date ? moment(item.application_date).format("DD MMM YYYY") : "-"}</Descriptions.Item>
                  <Descriptions.Item label="Tanggal Berakhir">{item.simper_expiry_date ? moment(item.simper_expiry_date).format("DD MMM YYYY") : "-"}</Descriptions.Item>
                  <Descriptions.Item label="Refresh Praktik">{item.refresh_practice || "-"}</Descriptions.Item>
                  <Descriptions.Item label="Tanggal Refresh">{item.refresh_date ? moment(item.refresh_date).format("DD MMM YYYY") : "-"}</Descriptions.Item>
                  <Descriptions.Item label="Tahun / Bulan Refresh">
                    {item.refresh_year || "-"} / {item.refresh_month || "-"}
                  </Descriptions.Item>
                  <Descriptions.Item label="Subkon">{item.subkon || "-"}</Descriptions.Item>
                  <Descriptions.Item label="Remark" span={2}>
                    {item.reconcile_remark || "-"}
                  </Descriptions.Item>
                  <Descriptions.Item label="Nilai">{item.score ?? "-"}</Descriptions.Item>
                  <Descriptions.Item label="Status Karyawan">{item.employment_status || "-"}</Descriptions.Item>
                  <Descriptions.Item label="Status Ujian">
                    <Badge variant={item.exam_status?.toLowerCase() === "passed" ? "success" : "pending"}>
                      {item.exam_status === "Passed" ? "Lulus" : item.exam_status === "Failed" ? "Tidak Lulus" : item.exam_status === "Pending" ? "Menunggu" : item.exam_status || "-"}
                    </Badge>
                  </Descriptions.Item>
                  <Descriptions.Item label="Tes Tertulis">
                    <span className="font-semibold">{item.written_test_score || 0}</span> ({item.written_test_result === "Pass" ? "Lulus" : item.written_test_result === "Fail" ? "Tidak Lulus" : item.written_test_result || "-"})
                  </Descriptions.Item>
                  <Descriptions.Item label="Tes Praktik">
                    <span className="font-semibold">{item.practical_test_score || 0}</span> ({item.practical_test_result === "Pass" ? "Lulus" : item.practical_test_result === "Fail" ? "Tidak Lulus" : item.practical_test_result || "-"})
                  </Descriptions.Item>
                  <Descriptions.Item label="Surat Keterangan" span={2}>
                    {item.certificate_sim || "-"}
                  </Descriptions.Item>
                  <Descriptions.Item label="Distribusi Simper">{item.simper_distribution || "-"}</Descriptions.Item>
                  <Descriptions.Item label="Status Simper">{simperStatusLabelMap[item.simper_status?.toLowerCase() || ""] || item.simper_status || "-"}</Descriptions.Item>
                  <Descriptions.Item label="Penguji" span={2}>
                    {item.examiner || "-"}
                  </Descriptions.Item>
                </Descriptions>
                {index < simperData.length - 1 && <Divider className="my-8" />}
              </List.Item>
            )}
          />
        ) : (
          <div className="py-12 flex flex-col items-center justify-center grayscale opacity-60">
            <Empty description="Belum ada riwayat detail simper" />
          </div>
        )}
      </CardContent>
    </Card>
  )
}

export default SimperHistoryCard
